import * as React from 'react';
import { Translation } from 'react-i18next';
import { Text } from '@wix/design-system';
import s from '../ChangePlanModal.scss';
import { ChangePlanModalPlanBox } from './ChangePlanModalPlanBox';

export const ChangePlanModalComparePlans = () => {
  return (
    <Translation>
      {(t) => (
        <section className={s.comparePlans} data-testid='change_plan_modal'>
          <div className={s.planBox}>
            <Text className={s.heading} size='tiny'>
              {t('change_plan.change_plan_modal.current_plan')}
            </Text>
            <ChangePlanModalPlanBox isCurrentPlan={true} />
          </div>
          <figure className={s.comparePlansSeparator} />
          <div className={s.planBox}>
            <Text className={s.heading} size='tiny'>
              {t('change_plan.change_plan_modal.changing_to')}
            </Text>
            <ChangePlanModalPlanBox isCurrentPlan={false} />
          </div>
        </section>
      )}
    </Translation>
  );
};
